// General imports
import "./components";
import "./initializers";
import "./template";
import "./vue";

const version_deploy = "15/10/2025 16:26'";
// console.log("Version deployed: " + version_deploy);
